module.exports = __webpack_public_path__ + "img/pamperlounge.a46d9404.jpg";